export default "__VITE_ASSET__DOtYmZwN__"